import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=4aa5e9f3&scoped=true"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCart.vue?vue&type=style&index=0&id=4aa5e9f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5e9f3",
  null
  
)

export default component.exports